import React from "react";

import { IConfimationViewProps } from "../../../interfaces/modals";

export const ConfirmationView = (props: IConfimationViewProps) => {
    const { title, content, onClose, cancelFn, cancelTxt, action, actionTxt } = props;

    const onCancel = () => {
        if (cancelFn) cancelFn();
        onClose();
    };

    return (
        <div className="immersion__message_modal__confirmation_view">
            <br />
            <h4 className="immersion__color__dark">{title}</h4>
            <p className="immersion__color__dark_grey">
                {content}
            </p>
            <br />
            <div className="immersion__message_modal__confirmation_actions">
                <button className="immersion__btn immersion__btn__secondary" onClick={onCancel}>{cancelTxt}</button>
                <button
                    className='immersion__btn immersion__btn__primary'
                    onClick={action}
                >
                    {actionTxt}
                </button>
            </div>
        </div>
    );
};